import React from 'react';
import Icon from './icon';
import { IconProps } from './types';

const ICON_PATH = 'M16.7364 5.51743C17.0879 5.1703 17.0879 4.60748 16.7364 4.26035C16.3849 3.91322 15.8151 3.91322 15.4636 4.26035L8.2636 11.3715C7.91213 11.7186 7.91213 12.2814 8.2636 12.6285L15.4636 19.7396C15.8151 20.0868 16.3849 20.0868 16.7364 19.7396C17.0879 19.3925 17.0879 18.8297 16.7364 18.4826L10.1729 12.0001L16.7364 5.51743Z';

export const ArrowPreviousIcon: React.FC<IconProps> = ({ size, color, style, viewBox }) => {
	return <Icon style={style} path={ICON_PATH} size={size} color={color} viewBox={viewBox} />;
};
